import { cn } from '@/shared/utils';

const FinishedCard = ({ data }) => {
  return (
    <article
      className={cn(
        'flex flex-1 justify-between max-md:flex-wrap',
        'gap-2 lg:gap-4',
        'p-4 lg:px-4 lg:py-2',
        'rounded-[8px]',
        'bg-[#1E202C]'
      )}
    >
      <header className="space-y-1 flex-1 my-auto min-w-20">
        <h5 className="text-lg font-semibold tracking-tight leading-5">
          {data.playerName}
        </h5>
        <p className="text-sm leading-4">{data.teamName}</p>
      </header>
      <time className="my-auto text-sm text-right leading-4 sm:text-center text-neutral-400 w-32">
        {new Date(data.date).toLocaleString('en-US', {
          weekday: 'long',
          day: '2-digit',
          month: 'short',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        })}
      </time>
      <ul className="flex gap-0.5 lg:gap-px my-auto self-stretch text-white flex-wrap w-full sm:w-auto sm:flex-1">
        {data.gameScores.map((score, index) => (
          <li
            key={index}
            className={cn(
              'py-[7px] min-w-8',
              'bg-[#397D5A]',
              'text-sm leading-4 text-center',
              'first-of-type:rounded-l last-of-type:rounded-r',
              'flex-1 lg:flex-none lg:w-11'
            )}
          >
            {score}
          </li>
        ))}
        {Array.from(
          { length: Math.max(0, 5 - data.gameScores.length) },
          (_, index) => (
            <li
              key={`empty-${index}`}
              className={cn(
                'py-[7px] min-w-8',
                'bg-[#171822]',
                'text-sm leading-4 text-center',
                'first-of-type:rounded-l last-of-type:rounded-r',
                'flex-1 h-[30px]',
                'lg:flex-none lg:w-11'
              )}
            ></li>
          )
        )}
      </ul>
      <aside className="flex items-center h-8 rounded overflow-hidden">
        <div className="flex justify-center items-center bg-[#2D4438] w-[14px] h-full">
          <span className="text-[8px] tracking-wide leading-loose uppercase -rotate-90">
            Total
          </span>
        </div>
        <span
          className={cn(
            'h-full bg-emerald-200 text-black text-3xl font-semibold',
            'flex justify-end items-center px-2 py-2',
            'w-12'
          )}
        >
          {data.totalScore}
        </span>
      </aside>
    </article>
  );
};

export default FinishedCard;
